import {updateRecentSearch} from '@stencil/hotels-utils/src/recent-search-util';
import {RESET_SEGMENT_SLIDER} from '@stencil/hotels-common-reducer/src/types';
import {GIPages} from '@stencil/hotels-types/src/hotels-types';
import {StaticDetailActionTypes} from '@stencil/hotels-cg-reducer/src/details/constants';
import getDetailsPageUrl, {
  getDetailsPageHotelRootUrl,
} from '@stencil/hotels-utils/src/get-details-page-url';
import getSrpUrl from '@stencil/hotels-utils/src/get-srp-url';
import getsemSrpUrl from '@stencil/hotels-utils/src/get-sem-srp-url';
import {useCallback} from 'react';
import {useStore, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {updateQueryAction} from '@stencil/hotels-common-reducer/src/actions';
import {
  IHotelData,
  IUpdate_Srp_Config,
  RESET_SRP_DATA,
  UPDATE_SRP_CONFIG,
  IUpdate_Filter,
} from '../pages/SRP/redux/types';
import transformVoyagerResultToFilter from '../utils/transformVoyagerResultToFilter';
import {resetStaticData, resetSearchRoomData} from '@stencil/hotels-cg-reducer/src/details/actions';

import {lobName, tagIds} from '@stencil/hotels-config';
import {setCommonsRecentSearchData} from '@stencil/hotels-utils/src/recent-search-utils';

//Actions
import {
  resetCGSRPDataReducerAction,
  resetSRPCGReducerAction,
  updateSRPCgConfig,
} from '@stencil/hotels-cg-reducer/src/srp/actions';

// Cross RS Utils
import {pushSearchesToApi} from '@growth/recent-search/helper';

// utils
import {buildGoData} from '@stencil/hotels-utils/src/build-go-data-utils';
import splitRoomString from '@stencil/hotels-utils/src/split-room-string';
import {
  convertAppliedLocationstoStr,
  convertToNewLocationFilter,
} from '@stencil/use-filter/src/filterUtils';
import useQuery from '@stencil/hotels-hooks/src/useQuery';
import {getNewUrl} from '@stencil/hotels-utils/src/get-new-flow-url';
import {getCmpCookieValue, isNewFLowUrl} from '@stencil/hotels-utils/src/common-utils';
import {channelSource} from '@stencil/hotels-config/src/config/app-config';

export interface IOnSearchNavigateDetails {
  openInNewTab?: boolean;
  hotelData?: IHotelData;
  newFilterData?: IUpdate_Filter['actionData'];
  resetAllData?: boolean;
  exclusions?: Array<string>;
  showOverlayLoader?: boolean;
  resetOldFilter?: boolean;
  detailToSrpFlag?: boolean;
  newTabDetails?: object;
  isSEMSearch?: boolean;
  clearAll?: boolean;
  isReplace?: boolean;
  doNotSaveRs?: boolean;
  openSRPForHotelSearch?: boolean;
  // srpUnifVersion?: boolean;
  customData?: object;
  isSrpAltAcco?: boolean;
  isDatePaxChange?: boolean;
}

export function useNavigateForSearchWidget() {
  const history = useHistory();
  const store = useStore();
  const dispatch = useDispatch();
  const {allParams} = useQuery();

  const appState = store.getState();

  const cmpCookieValue = getCmpCookieValue();

  const resetCaller = useCallback(() => {
    store.dispatch({type: RESET_SRP_DATA});
    store.dispatch({type: RESET_SEGMENT_SLIDER});
    store.dispatch({type: StaticDetailActionTypes.RESET_DETAILS_DATA});
  }, []);

  const resetCgDetailsCaller = useCallback(() => {
    dispatch(resetStaticData());
    dispatch(resetSearchRoomData());
  }, []);

  const updateSrpFilterCaller = useCallback((actionData: IUpdate_Srp_Config['actionData']) => {
    store.dispatch({type: UPDATE_SRP_CONFIG, actionData});
  }, []);

  // const fetchGoSuggestSrpDataThunkCaller = useCallback(({hotel_id}) => {
  //   store.dispatch(
  //     fetchGoSuggestSrpDataThunk({
  //       version: 'v13',
  //       flavour: 'v3',
  //       isLoginNowHotelID: hotel_id,
  //     }),
  //   );
  // }, []);

  const onSearch = (onSeachDetails: IOnSearchNavigateDetails = {}) => {
    const {
      openInNewTab = false,
      hotelData = null,
      newFilterData = {},
      resetAllData = true,
      exclusions = [],
      showOverlayLoader = false,
      resetOldFilter = false,
      detailToSrpFlag = false,
      newTabDetails = {},
      isSEMSearch = false,
      clearAll = false,
      isReplace = false,
      doNotSaveRs = false,
      openSRPForHotelSearch = false,
      // srpUnifVersion = false,
      customData = {},
      isSrpAltAcco = false,
      isDatePaxChange = false,
    } = onSeachDetails;

    const {srpUnif, common, details, detailsUnif} = store.getState();
    let {
      destination,
      locus,
      checkin,
      checkout,
      roomString,
      partner,
      metaPartner,
      country,
      selectedHotel,
      pokusExpData,
      checkinTime,
      newFilterData: unifFilterData = '',
      newLocationData = '',
      sortData = '',
      topHtlId = '',
      sType = '',
    } = common;

    const {srpConfig: srpUnifConfig} = srpUnif;
    const {metaPartner: metaPartnerUnif, isSeo: isSeoV2} = srpUnifConfig;
    const {deeplink_url_flow = false, dt_hotel_listing_new: pokusDwebSRPRevampPageUnif = false} =
      pokusExpData || {};

    //@Note This is for Home page searched hotel property, directing to srp page
    const goSuggest = !!((selectedHotel?.propertyId || selectedHotel?.mmtId) && metaPartnerUnif);

    const vcid = customData?.vcid;

    let isDetails = false;
    let detailsPageUrl = '';
    let srpUrl = '';
    let appliedFilters = {} as any;
    let isInternational = country !== 'IN';

    const searchText = allParams?.searchText || '';
    const isNewFlowOpen = isNewFLowUrl(location.pathname, partner);
    const haveLocus = !!(locus?.id && locus?.type);

    const isNewSrpFlow =
      haveLocus &&
      (isNewFlowOpen ||
        (deeplink_url_flow && pokusDwebSRPRevampPageUnif) ||
        customData?.isNewSrpFlow);
    const isNewDetailsFlow = haveLocus && isNewFlowOpen;

    const renderOldSrpFlow = !isNewSrpFlow && cmpCookieValue?.toUpperCase()?.startsWith('SEM|');

    if (
      (isNewFlowOpen && !haveLocus) ||
      (!isNewFlowOpen && (!destination || (!destination._id && !vcid && !hotelData)))
    ) {
      return;
    }

    const {paxCount, roomCount, childCount, childAgeArray} = splitRoomString(roomString);

    if (country !== 'IN' && partner !== 'hotels-international') {
      dispatch(
        updateQueryAction({
          partner: 'hotels-international',
        }),
      );
      partner = 'hotels-international';
    }

    if (country == 'IN' && partner !== 'hotels') {
      dispatch(
        updateQueryAction({
          partner: 'hotels',
        }),
      );
      partner = 'hotels';
    }

    let filter = transformVoyagerResultToFilter(destination) || {};
    let updatedNewLocationData = '';

    if (isNewSrpFlow && filter?.location_search?.length) {
      const filterData = filter?.location_search[0] || {};
      updatedNewLocationData = convertAppliedLocationstoStr({
        [filterData?.id_type]: [filterData],
      });
    } else if (!renderOldSrpFlow) {
      if (isDatePaxChange) {
        updatedNewLocationData = newLocationData;
      } else {
        updatedNewLocationData = !!filter?.location_search?.length
          ? convertToNewLocationFilter(filter.location_search)
          : '';
      }
      // newLocationData = !!filter?.location_search?.length
      //   ? convertAppliedLocationstoStr(filter.location_search)
      //   : '';

      dispatch(
        updateQueryAction({
          newLocationData: updatedNewLocationData,
        }),
      );
    }

    // @Note To save filter when user changes checkin and checkout & pax
    if (!resetOldFilter) {
      filter = {...filter};
    }

    let cityIdFromDestination = '';
    let overriderankvhids = '';
    const {t, ct = {}, _id = '', n = '', mmtId = ''} = destination;

    let hotelMmtId = goSuggest
      ? mmtId || selectedHotel?.mmtId || detailsUnif?.static?.hotelDetails?.id
      : '';

    // @Note Vcid has been added to handle back button from non seo to seo
    if ((ct && Object.keys(ct).length > 0) || _id || vcid) {
      cityIdFromDestination = ct._id || _id || vcid || '';
    }

    // @Note Vcid has been added to handle back button from non seo to seo
    if (!ct._id && !_id) {
      destination._id = vcid;
    }

    let hasNewFiltersToBeApplied = false;
    if (newFilterData && Object.keys(newFilterData).length) {
      hasNewFiltersToBeApplied = true;
    }

    let detailsPageCondition =
      ((selectedHotel && selectedHotel.propertyName) ||
        (newTabDetails && newTabDetails.hn) ||
        (hotelData && hotelData.hn && !hasNewFiltersToBeApplied)) &&
      !detailToSrpFlag &&
      !goSuggest;

    filter = {
      ...filter,
    };

    if (partner === 'gostays' && exclusions && !exclusions.includes('gostays')) {
      filter.tag = 'goStays';
    }

    if (!openInNewTab) {
      if (resetAllData) resetCaller();
      if (isSeoV2) {
        dispatch(updateSRPCgConfig({isSeo: false}));
      }
    }
    if (
      ((selectedHotel && selectedHotel.propertyName) ||
        (newTabDetails && newTabDetails.hn) ||
        (hotelData && hotelData.hn && !hasNewFiltersToBeApplied) ||
        (destination?.t == 'hotel' && destination?.n && destination?._id)) &&
      !detailToSrpFlag &&
      !goSuggest
    ) {
      const {staticData = {}} = details || {};
      isDetails = true;
      appliedFilters = hotelData?.af;
      const urlPayloadData = {
        mmtId: selectedHotel?.mmtId,
        propertyName: selectedHotel?.propertyName,
        propertyId: selectedHotel?.propertyId,
        checkin,
        checkout,
        roomString,
        destination,
        locus,
        partner,
        metaPartner,
        country,
        staticData,
        offerCode: '',
        cityId: openInNewTab ? vcid : cityIdFromDestination,
        appliedFilters: hotelData?.af,
        appliedFiltersUniFormat: hotelData?.appliedFiltersUniFormat || [],
        hotelData: hotelData
          ? hotelData
          : selectedHotel?.propertyId
            ? {
                hn: selectedHotel.propertyName,
                hc: selectedHotel.propertyId,
              }
            : {
                hn: n,
                hc: _id,
              },
        srpContinuedFilters: {},
        isSrpAltAcco,
        topHtlId,
        sType,
      };
      detailsPageUrl = isNewDetailsFlow
        ? getNewUrl(urlPayloadData, 'details')
        : getDetailsPageUrl(urlPayloadData);
      if (openInNewTab) {
        window.open(detailsPageUrl, '_blank');
      } else {
        resetCgDetailsCaller();
        if (isReplace) {
          history.replace(detailsPageUrl);
        } else {
          history.push(detailsPageUrl);
        }
      }
    } else {
      appliedFilters = !renderOldSrpFlow
        ? {}
        : {
            ...filter,
            ...newFilterData,
          };

      let enhancedLocus = goSuggest ? {...locus, search: 'hotel'} : locus;

      if (isSEMSearch) {
        srpUrl = getsemSrpUrl({
          checkin,
          checkout,
          destination,
          roomString,
          country,
          filter: appliedFilters,
          overriderankvhids: overriderankvhids,
          partner,
        });
      } else {
        const urlPayloadData = {
          searchText,
          checkin,
          checkout,
          destination: destination,
          locus: enhancedLocus,
          roomString,
          country,
          filter: appliedFilters,
          partner,
          selectedRegionCity: {},
          openSRPForHotelSearch,
          hotelId: overriderankvhids,
          newLocationData: customData?.newLocationData || updatedNewLocationData,
          newFilterData: customData?.newFilterData || unifFilterData,
          mmtId: hotelMmtId,
          sType: sType,
        };
        srpUrl = isNewSrpFlow ? getNewUrl(urlPayloadData) : getSrpUrl(urlPayloadData);
      }
      if (openInNewTab) {
        window.open(srpUrl, '_blank');
      } else {
        dispatch(resetSRPCGReducerAction());
        dispatch(resetCGSRPDataReducerAction());
        if (isReplace) {
          history.replace(srpUrl);
        } else {
          history.push(srpUrl);
        }
      }
    }

    const cityName = customData?.cityName || ct?.n || n || '';
    const cityId = ct?._id || vcid || _id;
    const propertyName = hotelData?.hn || selectedHotel?.propertyName || '';
    const propertyId = (hotelData?.hc as any) || selectedHotel?.propertyId || '';
    const destinationType = propertyId ? 'hotel' : destination?.t;

    const goData = buildGoData({
      page: isDetails ? GIPages.Details : GIPages.Srp,
      cityId,
      cityName,
      destinationType,
      cityMetaEid: destination?._id,
      checkInDate: checkin,
      checkOutDate: checkout,
      roomString,
      appliedFilter: appliedFilters,
      propertyId,
      propertyName,
      countryCode: country,
      locus,
      mmtId: hotelMmtId,
    });

    if (doNotSaveRs) {
      return;
    }

    const data = setCommonsRecentSearchData({
      tagId: isDetails ? tagIds.detail : tagIds.srp,
      godata: goData,
      name: isDetails ? propertyName : destination?.n,
      adultCount: paxCount,
      childCount,
      childAgeArray,
      roomCount: roomCount,
      title: isDetails ? propertyName : destination?.n,
      cityName,
      cityId,
      lobName: lobName,
      traveldate: new Date(checkin?.date),
      returnDate: new Date(checkout?.date),
      url: isDetails ? detailsPageUrl : srpUrl,
      locus,
      subLob: destinationType,
      type: destinationType,
      isInternational,
      countryCode: country,
      roomString,
      hotelId: propertyId,
    });

    /* New Recent Search Setter */
    pushSearchesToApi({
      lobName,
      searchDetails: data,
      onPushSuccess: r => {},
      onPushFail: e => {
        /** page is broken if this fails */
        try {
          console.log('pushSearchesToApi failed', e);
        } catch (e) {
          console.log('pushSearchesToApi failed', e);
        }
      },
    });

    const hotelCode =
      openSRPForHotelSearch && overriderankvhids ? overriderankvhids : hotelData?.hc;
    /* Old Recent Search Setter */
    updateRecentSearch({
      destination,
      checkin,
      checkout,
      roomString,
      partner,
      hotelName: hotelData?.hn,
      hotelCode: hotelCode,
      country,
      locus,
      openSRPForHotelSearch,
    });
  };

  const getSeoDetailsUrl = (item: IHotelData = null) => {
    const {common} = store.getState();
    const {checkin, checkout, roomString, partner, destination, country, locus} = common;
    const url = getDetailsPageUrl({
      hotelData: item,
      partner,
      checkin,
      checkout,
      roomString,
      offerCode: '',
      destination,
      country,
      cityId: '',
      locus,
    });
    return url;
  };

  const getSeoDetailsBaseUrl = (item: IHotelData = null) => {
    const {common} = store.getState();
    const {checkin, checkout, roomString, partner, destination} = common;
    const url = getDetailsPageHotelRootUrl({
      hotelData: item,
      partner,
      checkin,
      checkout,
      roomString,
      destination,
    });
    return url;
  };

  return {onSearch, getSeoDetailsUrl, getSeoDetailsBaseUrl};
}
